
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutStory from './components/AboutStory';
import AboutTeam from './components/AboutTeam';
import AboutValues from './components/AboutValues';
import AboutStats from './components/AboutStats';

export default function About() {
  useEffect(() => {
    // SEO Meta Tags
    document.title = 'À Propos - Cobra Sécurité | Expertise Sécurité Tunisie';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Découvrez Cobra Sécurité, votre partenaire de confiance en solutions de sécurité en Tunisie. Plus de 15 ans d\'expérience, équipe d\'experts certifiés et technologies de pointe.');
    }
    
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`);
    }

    // Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "À Propos de Cobra Sécurité",
      "description": "Découvrez l'histoire et l'expertise de Cobra Sécurité en solutions de sécurité",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`,
      "mainEntity": {
        "@type": "Organization",
        "name": "Cobra Sécurité",
        "foundingDate": "2008",
        "description": "Entreprise spécialisée en solutions de sécurité professionnelles",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "TN",
          "addressRegion": "Tunis"
        },
        "employee": [
          {
            "@type": "Person",
            "name": "Ahmed Ben Salem",
            "jobTitle": "Directeur Technique"
          },
          {
            "@type": "Person",
            "name": "Fatma Trabelsi",
            "jobTitle": "Responsable Commercial"
          },
          {
            "@type": "Person",
            "name": "Mohamed Gharbi",
            "jobTitle": "Ingénieur Sécurité"
          }
        ]
      }
    });
    
    document.head.appendChild(schemaScript);

    return () => {
      document.head.removeChild(schemaScript);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <h1 style={{ position: 'absolute', left: '-9999px' }}>À Propos de Cobra Sécurité</h1>
        <AboutHero />
        <AboutStory />
        <AboutValues />
        <AboutStats />
        <AboutTeam />
      </main>
      <Footer />
    </div>
  );
}
